import { render, staticRenderFns } from "./LibraryArticleDialog.vue?vue&type=template&id=c8b187d8&scoped=true"
import script from "./LibraryArticleDialog.vue?vue&type=script&lang=js"
export * from "./LibraryArticleDialog.vue?vue&type=script&lang=js"
import style0 from "./LibraryArticleDialog.vue?vue&type=style&index=0&id=c8b187d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b187d8",
  null
  
)

export default component.exports